import React from 'react';

const TextInputField = ({ name, defaultValue, onChange, placeholder, disabled }) => {
  return (
    <input
      disabled={disabled}
      type="text"
      name={name}
      defaultValue={defaultValue}
      onChange={onChange}
      placeholder={placeholder}
      className="form-control form-control-solid h-10 py-2 px-6"
    />
  );
};

export default TextInputField;